import { useEventListener } from 'usehooks-ts'

import { useCartStore } from '@entities/Cart'

export default function useCartSyncStorage () {
  const rehydrate = useCartStore.persist?.rehydrate

  useEventListener('storage', (event: StorageEvent) => {
    if (event.key === 'cart-storage') {
      rehydrate?.()
    }
  })
}
